import { IServiceRequestClients } from '@commenda/types/src/service-request/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { API_BASE_PATH } from './constants';

export interface ServiceRequestAssignedBusinessEntitiesResponse {
  corporations: IServiceRequestClients[];
  count: number;
}

export const useServiceRequestAssignedBusinessEntities = (serviceRequestId: string) => {
  const {
    data,
    error,
    mutate,
    isLoading,
  }: {
    data?: ServiceRequestAssignedBusinessEntitiesResponse;
    error?: unknown;
    mutate: KeyedMutator<ServiceRequestAssignedBusinessEntitiesResponse | undefined>;
    isLoading: boolean;
  } = useSWR(
    serviceRequestId ? `${API_BASE_PATH}/${serviceRequestId}/assigned-business-entities` : null,
    SWRFetcher(
      {
        method: 'GET',
      },
      undefined
    )
  );

  return {
    data,
    error,
    mutate,
    isLoading,
  };
};
